import useInView from '../../Hooks/useInView'

const Animate = ({
  children,
  type = 'fade-up',
  delay = 0,
  tag: Tag = 'div',
  className = '',
  style = {},
  threshold,
  ...props
}) => {
  const [ref, inView] = useInView(threshold)

  return (
    <Tag
      ref={ref}
      className={`anim anim--${type}${inView ? ' anim--visible' : ''}${className ? ` ${className}` : ''}`}
      style={delay ? { animationDelay: `${delay}s`, ...style } : style}
      {...props}
    >
      {children}
    </Tag>
  )
}

export default Animate
